import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';

/**
 * The company portal this deployment serves. The public API scopes every read by
 * `{companySlug}` (`/api/v1/public/{companySlug}/positions`), and the portal routes carry no
 * company prefix, so the slug is deployment configuration: one portal build per tenant today,
 * resolved from the hostname once portal custom domains land (docs/09 Enterprise tier).
 * `nordic-byte` is the seeded demo company (NordicByteDemoData.CompanySlug).
 */
export const PORTAL_COMPANY_SLUG = new InjectionToken<string>('RK_PORTAL_COMPANY_SLUG', {
  providedIn: 'root',
  factory: () => 'nordic-byte',
});

/** Per-deployment company slug for the portal; provided from the environment's `companySlug`. */
export function providePortalCompany(companySlug: string): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: PORTAL_COMPANY_SLUG, useValue: companySlug }]);
}
